<template>
  <div class="vap-page">
    <Loading
      :active.sync="isLoading"
      :is-full-page="false"
      :color="loaderColor"
      loader="dots"
      :background-color="loaderBackgroundColor"
    />
    <div class="vap-page-header">
      <h1>Group Management</h1>
      <div class="btns-container">
        <VasionButton
          v-show="activeTab === 'internal' || hasPortalUserLicense"
          classProp="primary"
          @vasionButtonClicked="newGroupClick"
        >
          {{ newGroupButtonLabel }}
        </VasionButton>
      </div>
    </div>
    <div class="vap-page-content">
      <div class="tabs-list-container">
        <VasionButton
          v-for="(tab, tabIndex) in tabs"
          :id="`tab-group-${tab.name}`"
          :key="tabIndex"
          :classProp="activeTab === tab.name ? 'text-selected' : 'text'"
          @vasionButtonClicked="setActiveTab(tab.name)"
        >
          {{ tab.label }}
        </VasionButton>
      </div>
      <div class="tabs-item-container">
        <div v-if="activeTab === 'portal' && !hasPortalUserLicense" class="portal-no-license-message">
          You are not licensed for portal users. Please contact your sales representative to add this feature.
        </div>
        <GroupsTabContent v-else ref="refGroupsTabContent" />
      </div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import { loaderBackgroundColor, loaderColor } from '@/assets/js/styleConfig'
import GroupsTabContent from '@/views/admin/securityPermissions/GroupsTabContent.vue'

export default {
  name: 'Groups',
  components: {
    GroupsTabContent,
    Loading,
  },
  data: function () {
    return {
      activeTab: null,
      isLoading: false,
      loaderBackgroundColor: loaderBackgroundColor,
      loaderColor: loaderColor,
      tabs: [
        { name: 'internal', label: 'Internal' },
        { name: 'portal', label: 'Portal' },
      ],
    }
  },
  computed: {
    hasPortalUserLicense() {
      return this.$store.state.admin.hasPortalUserLicense
    },
    newGroupButtonLabel() {
      return this.activeTab === 'portal' ? 'New Portal Group' : 'New Group'
    },
  },
  async created() {
    await this.loadInitialData()
    // Set default tab
    const defaultTabToSet = 'internal'
    const internalTab = this.tabs.find(tab => tab.name === defaultTabToSet)
    this.activeTab = internalTab ? internalTab.name : this.tabs[0].name
  },
  beforeDestroy() {
    this.$store.dispatch('security/setGroupType', 'internal')
  },
  methods: {
    handleExportGroupsList() {
      console.log('Export Groups List button clicked')
    },
    hideLoading() {
      this.setLoading(false)
    },
    async loadInitialData() {
      this.showLoading()
      try {
        await Promise.all([
          this.$store.dispatch('security/loadGroupList'),
          this.$store.dispatch('admin/getLicenseAvailabilityForUserUpsert'),
        ])
        this.$refs.refGroupsTabContent?.refreshTable()
        this.hideLoading()
      } catch (error) {
        console.error('Error loading initial data:', error)
        this.hideLoading()
      }
    },
    newGroupClick() {
      this.$refs.refGroupsTabContent?.editGroupClick(0)
    },
    async setActiveTab(tabName) {
      const tab = this.tabs.find(tab => tab.name === tabName)
      this.activeTab = tab ? tab.name : this.tabs[0].name

      await this.$store.dispatch('security/setGroupType', this.activeTab)
    },
    setLoading(isLoading) {
      this.isLoading = isLoading
    },
    showLoading() {
      this.setLoading(true)
    },
  },
}
</script>

<style lang="scss" scoped>
.vap-page-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
}

.tabs-list-container {
  flex-shrink: 0;
}
.tabs-list-container ::v-deep button:first-of-type {
  margin-left: 0;
}
.tabs-list-container ::v-deep button:last-of-type {
  margin-right: 0;
}

.portal-no-license-message {
  margin-top: 16px;
  padding: 16px;
  color: inherit;
}

.tabs-item-container {
  flex-grow: 1;
  overflow-y: auto;
  height: 100%;
}
</style>
